import { Component, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { nameof } from 'ts-simple-nameof';
import { DialogDataService } from '../../../../../dialog/dialog-data.service';
import { DialogService } from '../../../../../dialog/dialog.service';
import { QuestionDefinition } from '../../../../../forms/form.types';
import { GenericFormGroupComponent } from '../../../../../forms/generic-form-group.component';
import { ValidGradingRankCode } from '../../../../../shared/interface/valid-grading-rank-code.interface';
import { FacultyCategoryService } from '../faculty-category.service';

@Component({
    selector: 'app-faculty-category-edit',
    templateUrl: './faculty-category-edit.component.html',
    styleUrls: ['./faculty-category-edit.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class FacultyCategoryEditComponent extends GenericFormGroupComponent implements OnInit {
    controls: {
        id: FormControl<number>;
        rankCode: FormControl<string>;
        isEnabled: FormControl<boolean>;
    };

    questions: {
        rankCode: QuestionDefinition;
        isEnabled: QuestionDefinition;
    };

    constructor(
        private dataService: DialogDataService<ValidGradingRankCode>,
        private dialogService: DialogService<ValidGradingRankCode>,
        private service: FacultyCategoryService,
        protected renderer2: Renderer2
    ) {
        super(renderer2);
        this.controls = {
            id: new FormControl<number>(this.dataService?.data?.id, Validators.required),
            rankCode: new FormControl<string>(this.dataService?.data.rankCode, Validators.required),
            isEnabled: new FormControl<boolean>(this.dataService?.data?.isEnabled ?? false)
        };
        this.createFormGroup(this.controls);
        if (this.reflectionService.isNotNullOrEmpty(this.dataService.data.rankCode)) {
            this.controls.rankCode.disable();
        }
        this.questions = {
            rankCode: {
                input: {
                    discriminator: 'SELECT',
                    property: nameof<ValidGradingRankCode>((m) => m.rankCode),
                    control: this.controls.rankCode,
                    required: true,
                    options$: this.service.selectList({ q: this.controls.rankCode.value })
                }
            },
            isEnabled: {
                input: {
                    discriminator: 'CHECKBOX',
                    property: nameof<ValidGradingRankCode>((m) => m.isEnabled),
                    label: 'Check this check box to enable this code',
                    control: this.controls.isEnabled
                }
            }
        };
        this.dialogService.addFormGroup(this, this.dataService.uniqueId);
    }

    ngOnInit(): void {}

    onSave() {
        this.setSaving();
        this.service
            .savePromise(this.getFormValue(), 'Staff Code Saved!')
            .then((m) => {
                this.setDoneSaving();
                this.dialogService.send(this.dataService, m);
                this.controls.id.setValue(m.id);
            })
            .catch(() => {
                this.setDoneSaving();
            });
    }

}
